import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ButtonComponent, IDynamicElement, LinkDirective } from '@sirius/common';
import { ICtaPanel, ICtaSideBySide } from 'shared/models';

let nextBlockId = 0;

/** A panel renders at most this many buttons. Storyblok caps the field at two as well; this is belt and braces. */
const MAX_BUTTONS = 2;

/**
 * The CTA Side by Side block: two call-to-action panels next to each other, the first dark blue and the second light
 * neutral (colours follow position, there is no theme field). Registered as the `cta-side-by-side` dynamic element
 * (CMS block `cta-side-by-side-v1`). Every panel arrives fully resolved from the backend; this component only
 * lays it out.
 */
@Component({
    selector: 'ur-cta-side-by-side',
    templateUrl: './cta-side-by-side.component.html',
    styleUrl: './cta-side-by-side.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonComponent, LinkDirective],
})
export class CtaSideBySideComponent implements IDynamicElement<ICtaSideBySide> {
    readonly config = input<ICtaSideBySide>();

    private readonly idPrefix = `ur-cta-side-by-side-${nextBlockId++}`;

    protected readonly panels = computed<ICtaPanel[]>(() =>
        (this.config()?.panels ?? []).map((panel) => ({
            ...panel,
            buttons: (panel.buttons ?? []).slice(0, MAX_BUTTONS),
        }))
    );

    protected headingId(index: number): string {
        return `${this.idPrefix}-title-${index}`;
    }
}
